import type { FaireProductEntity } from "../../entity_types/product";

export const p_7773hw9ftf: FaireProductEntity = {
  token: "p_7773hw9ftf",
  type: "product",
  name: "Canggu Anklet | Boho Surfer Beach Jewelry",
  brandName: "HALT",
  imageUrl:
    "https://cdn.faire.com/fastly/265412a15765972f9ef0729b6d37455a9da4a9d440a283328de62ce70edcd016.png",
  priceDollars: 4.99,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/8f1cfefe343aa4dd43ac82f78eb41cee8bc1aac46c1af0e0259b89e17aa3038b.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
